import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import Reveal from "./Reveal";
import { useT } from "../../i18n/I18nContext";

export const FAQ = () => {
  const t = useT();
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 lg:py-32 bg-[#F8FAFC] border-y border-slate-200/60"
    >
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="text-center">
          <Reveal>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#2563EB]">
              {t.faq.eyebrow}
            </p>
          </Reveal>
          <Reveal delay={60}>
            <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0A2342] tracking-tight leading-[1.1]">
              {t.faq.title}
            </h2>
          </Reveal>
        </div>

        <Reveal delay={120}>
          <div className="mt-12 bg-white rounded-2xl border border-slate-200/70 p-3 sm:p-5 shadow-sm">
            <Accordion type="single" collapsible className="w-full">
              {t.faq.items.map((f, i) => (
                <AccordionItem
                  key={f.q}
                  value={`item-${i}`}
                  data-testid={`faq-item-${i}`}
                  className="border-b border-slate-200 last:border-0"
                >
                  <AccordionTrigger className="text-left text-base sm:text-lg font-semibold text-[#0A2342] hover:no-underline py-5 px-3">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-slate-600 leading-relaxed text-[15px] px-3 pb-5">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default FAQ;
